import { getCookie } from 'utils/cookies'

const usercentricsConsentId = 'usercentrics_consent'
const functional = 'functional'

const checkConsent = (): boolean => {
  const usercentricsConsent = getCookie(usercentricsConsentId)

  if (typeof usercentricsConsent !== 'string') return false

  try {
    const isConsentGiven = JSON.parse(usercentricsConsent)[functional]
    return isConsentGiven === true || isConsentGiven === 1
  } catch (error) {
    return false
  }
}

export default checkConsent
